<template>
  <div>
    <Subheader title="Answer Questions" />

    <div class="app-content-column">
      <div v-if="dataLoaded" class="card">
        <h3>Questions</h3>
        <h5>You have {{ unansweredQuestions.length }} unanswered questions.</h5>
        <div v-if="unansweredQuestions.length === 0">You have answered all your questions!</div>

        <div v-for="question in unansweredQuestions" :key="question.id">
          {{ question.authorRef.username }} asked "{{ question.text }}"
          <h6>Please type your answer below</h6>
          <textarea
            :id="`newAnswer-${question.id}`"
            v-model="question.newAnswer"
            class="textarea"
            cols="30"
            rows="10"
          ></textarea>
          <div class="button-wrapper is-centered">
            <button class="small-button" @click="createNewAnswer(question.id, question.newAnswer)">
              {{ unansweredQuestions.length > 1 ? 'Next' : 'Finish' }}
            </button>
          </div>
        </div>
      </div>

      <router-link :to="{ name: 'Project', params: { projectId: project } }" class="return-link">
        <h5>Return to Project</h5>
      </router-link>
    </div>
  </div>
</template>

<script>
import Subheader from '@/components/Subheader'

import Question from '@/services/questions'
import Answer from '@/services/answers'

export default {
  name: 'Questions',
  components: {
    Subheader,
  },
  data() {
    return {
      dataLoaded: false,
      projectFilters: {
        project: null,
      },
      project: null,
      questions: [],
    }
  },
  computed: {
    unansweredQuestions() {
      if (this.questions.length === 0) return this.questions
      // TODO: This should be a filter on the back end
      return this.questions.filter(question => question.answersRef.length === 0)
    },
  },
  created() {
    this.project = this.$route.params.projectId
    this.projectFilters.project = this.$route.params.projectId
    this.refreshData()
  },
  methods: {
    refreshData() {
      Question.api.list({ filters: this.projectFilters }).then(data => {
        this.questions = data.results
        this.dataLoaded = true
      })
    },
    createNewAnswer(questionId, answer) {
      const newAnswer = Answer.create({
        question: questionId,
        text: answer,
      })
      Answer.api.create(newAnswer).then(() => {
        this.$Alert.alert({
          type: 'success',
          message: `<h2>Answer Submitted</h2>`,
          timeout: 3000,
        })
        this.refreshData()
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/mixins/buttons';
@import '../styles/mixins/cards';
@import '../styles/forms';
@import '../styles/layout';

.card {
  @include card-w-borders();
}

.return-link {
  display: flex;
  margin: 2rem 1rem;
}
</style>
